module.exports = __webpack_public_path__ + "static/mergesort-1.1-174809cbedf913fc806d69ba5a5de13a.png";